import React from "react";
import AntdCheckbox, { CheckboxProps } from "antd/lib/checkbox";
import {withError} from '@fishx/tracker';

const Group = AntdCheckbox.Group;
interface FCCheckboxProps extends React.FC<CheckboxProps> {
  Group: typeof Group;
}
export const Checkbox: FCCheckboxProps = (props) => {
  const { children } = props;
  return (
    <AntdCheckbox {...props}>{children}</AntdCheckbox>
  );
}
Checkbox.Group = Group;
Checkbox.displayName = 'Checkbox';
export default withError(Checkbox);



// WEBPACK FOOTER //
// ./src/components/checkbox/index.tsx